import React, { useState } from 'react';
import { useAuth } from '../auth/useAuth';
import './ImpersonationBanner.css';

// Liegt in App.js außerhalb des <RouterProvider> (wie InstallBanner/UpdateBanner),
// daher kein useNavigate() verfügbar — Rücksprung per vollem Reload, das lädt
// gleichzeitig frische Claims/Ansicht für den wieder angemeldeten Admin.
export default function ImpersonationBanner() {
  const { user, activeImpersonation, endImpersonation } = useAuth();
  const [ending, setEnding] = useState(false);

  if (!activeImpersonation) return null;

  async function handleEnd() {
    setEnding(true);
    try {
      await endImpersonation();
      window.location.href = '/admin/users';
    } catch (err) {
      console.error('[ImpersonationBanner] Beenden fehlgeschlagen:', err);
      setEnding(false);
    }
  }

  return (
    <div className="impersonation-banner" role="alert">
      <div className="impersonation-banner__content">
        <span className="impersonation-banner__icon">🕵️</span>
        <div className="impersonation-banner__text">
          <strong>Ansicht als: {user?.email || 'Nutzer'}</strong>
          <span>Gestartet von {activeImpersonation.adminEmail}</span>
        </div>
      </div>
      <button
        className="impersonation-banner__btn"
        onClick={handleEnd}
        disabled={ending}
      >
        {ending ? 'Beende…' : 'Beenden'}
      </button>
    </div>
  );
}
